// CANONICAL COPY (GH #7115). src/constants/obligations/obl-access-control-policy.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-access-control-policy',
  title: 'Verify access control policy is in place',
  description:
    'Confirm that access control rules are documented, published, and cover both physical and logical access. Access to information and system functions shall be restricted in accordance with the policy, implementing least-privilege principles.',
  category: 'access',
  scfIds: ['SCF-IAM-001', 'SCF-IAM-006'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Access control policy is published' },
    { type: 'document-approved', description: 'Policy has been approved' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
